import { Dialog, VisuallyHidden, Inset } from '@radix-ui/themes'
import { styles } from './styles.css'
import close from './images/close.svg'

type Props = {
  title: string
  renderTrigger: () => React.ReactNode
  renderContent?: () => React.ReactNode
}

export const Modal: React.FC<Props> = ({ title, renderTrigger, renderContent }) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger>{renderTrigger()}</Dialog.Trigger>
      <Dialog.Content className={styles.content} width="calc(100vw - 48px)" height="calc(100dvh - 144px)" maxWidth="500px" aria-describedby={undefined}>
        <VisuallyHidden>
          <Dialog.Title>{title}</Dialog.Title>
        </VisuallyHidden>
        <Inset side="all">
          {renderContent()}
        </Inset>
        <div className={styles.close}>
          <Dialog.Trigger>
            <img src={close} />
          </Dialog.Trigger>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  )
}
